import { DEFAULT_LEASE_TERM, REPAYMENT_WEEKLY } from '../constants';
import { getDefaultLeaseTermOption, getLeaseTermOptionFromQuery, getRepaymentOptionFromQuery } from './leaseTermUtils';

export function readLeaseTermFromQuery(query, leaseTermOptions, defaultLeaseTerm) {
  const leaseTermFromQuery = getLeaseTermOptionFromQuery(leaseTermOptions, query?.leaseTerm);
  const defaultLeaseTermOption =
    getDefaultLeaseTermOption(leaseTermOptions, defaultLeaseTerm || DEFAULT_LEASE_TERM) || leaseTermOptions[0] || null;

  return leaseTermFromQuery || defaultLeaseTermOption;
}

export function readRepaymentFromQuery(query) {
  return getRepaymentOptionFromQuery(query?.budgetType) || REPAYMENT_WEEKLY;
}

export function buildQueryWithLeaseTerm(routeQuery, leaseTerm, leaseTermOptions, defaultLeaseTerm) {
  const selectedLeaseTerm = leaseTerm?.value;
  const defaultLeaseTermValue = getDefaultLeaseTermOption(leaseTermOptions, defaultLeaseTerm || DEFAULT_LEASE_TERM)?.value;
  const currentQueryLeaseTerm = routeQuery?.leaseTerm;
  const normalizedCurrentQueryLeaseTerm =
    typeof currentQueryLeaseTerm === 'string' ? parseInt(currentQueryLeaseTerm, 10) : currentQueryLeaseTerm;

  if (!selectedLeaseTerm && currentQueryLeaseTerm === undefined) return null;
  if (selectedLeaseTerm === defaultLeaseTermValue && currentQueryLeaseTerm === undefined) return null;
  if (selectedLeaseTerm === normalizedCurrentQueryLeaseTerm) return null;

  const nextQuery = { ...(routeQuery || {}) };

  if (!selectedLeaseTerm || selectedLeaseTerm === defaultLeaseTermValue) {
    delete nextQuery.leaseTerm;
  } else {
    nextQuery.leaseTerm = String(selectedLeaseTerm);
  }

  return nextQuery;
}

export function buildQueryWithBudgetType(routeQuery, repayment) {
  const currentQueryRepayment = getRepaymentOptionFromQuery(routeQuery?.budgetType);

  if (!repayment && currentQueryRepayment === undefined) return null;
  if (repayment === REPAYMENT_WEEKLY && currentQueryRepayment === undefined) return null;
  if (repayment === currentQueryRepayment) return null;

  const nextQuery = { ...(routeQuery || {}) };

  if (!repayment || repayment === REPAYMENT_WEEKLY) {
    delete nextQuery.budgetType;
  } else {
    nextQuery.budgetType = repayment;
  }

  return nextQuery;
}
